(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:SendAlertCtrl
     *
     * @description
     *
     */
    angular
        .module('bidding')
        .controller('maxCrewBiddingctrl', maxCrewBiddingctrl);

    function maxCrewBiddingctrl($uibModalInstance, modalParams, MessageService, EventManagerService, PopupManager) {
        
    	var vm = this;
    	vm.maxBiddingSettingsData = angular.copy(modalParams.maxCrewBiddingsDTOs);	
    	
    	vm.onCloseClick = function () {
			PopupManager.closeModal('MAX_BIDDING_SETTINGS');
        };
        
        vm.onSaveBiddingSettings = function (param) {
        	EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_BIDDING.SAVE_MAX_CREW_BIDDING,param);	
        };	 
    }
}());
